import { mergeStoredKycUploadFlag, nextCkycVerificationFromPayload } from "helper/kycDocumentUpload";
import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";

import { onboardingConstants } from "./onboardingConstants";

const initialState = {
  currentStage: 0,
  riskMasterId: null,
  riskProfileName: null,
  suggestedRiskId: null,
  investmentAmount: null,
  investmentTenure: null,
  investmentStrategy: null,
  isOnboardingCompleted: 0,
  isPaymentCompleted: 0,
  minInvestmentAmount: 50000,
  minimumAdditionalInvestAmount: 10000,
  portfolioGeneratedDate: null,
  hasOnboardingInvestmentDetailsConfirmed: 0,
  expiryDate: null,
  dateOfBirth: null,
  pan: null,
  aadharNumber: null,
  isPanUploaded: 0,
  isAadhaarFrontUploaded: 0,
  isAadhaarBackUploaded: 0,
  documentStatus: "",
  panVerification: "",
  aadharFrontVerification: "",
  aadharBackVerification: "",
  planId: null,
  customerSubscriptionId: null,
  isMobileVerified: null,
  sourceType: null,
  isAllInOneSubscriptionActive: null,
  allInOnePlanFrequency: null,

  portfolioData: [],
  marketBreakupData: [],
  sectorBreakupData: [],
  pricingData: {},

  isInitialFetched: 0,
  loading: {
    onboardingData: 0,
    portfolioData: 0,
    pricingData: 0,
  },
};

export const onboardingReducers = persistReducer(
  {
    storage,
    key: "onboarding",
    blacklist: [
      "portfolioData",
      "marketBreakupData",
      "sectorBreakupData",
      "pricingData",
      "loading",
      "rmsOnboarding",
      "rmsOnboardingSteps",
      "isInitialFetched",
      "isMobileVerified",
    ],
  },
  (state = initialState, { type, payload }) => {
    switch (type) {
      case onboardingConstants.UPDATE_ONBOARDING_DATA: {
        const nextPlanId =
          payload.planId === undefined ? state.planId : payload.planId;
        return {
          ...state,
          currentStage: payload.currentStage ?? state.currentStage,
          riskMasterId: payload.riskMasterId ?? state.riskMasterId,
          riskProfileName: payload.riskProfileName ?? state.riskProfileName,
          suggestedRiskId: payload.suggestedRiskId ?? state.suggestedRiskId,
          investmentAmount: payload.investmentAmount ?? state.investmentAmount,
          investmentTenure: payload.investmentTenure ?? state.investmentTenure,
          investmentStrategy: [undefined, null].includes(
            payload.investmentStrategy,
          )
            ? state.investmentStrategy
            : payload.investmentStrategy,
          isOnboardingCompleted:
            payload.isOnboardingCompleted ?? state.isOnboardingCompleted,
          isPaymentCompleted:
            payload.isPaymentCompleted ?? state.isPaymentCompleted,
          minInvestmentAmount:
            payload.minInvestmentAmount ?? state.minInvestmentAmount,
          minimumAdditionalInvestAmount:
            payload.minimumAdditionalInvestAmount ??
            state.minimumAdditionalInvestAmount,
          portfolioGeneratedDate:
            payload.portfolioGeneratedDate ?? state.portfolioGeneratedDate,
          expiryDate: payload.expiryDate ?? state.expiryDate,
          isInitialFetched: payload.isInitialFetched ?? state.isInitialFetched,
          planId: nextPlanId,
          hasOnboardingInvestmentDetailsConfirmed:
            payload.hasOnboardingInvestmentDetailsConfirmed ??
            state.hasOnboardingInvestmentDetailsConfirmed,
          customerSubscriptionId:
            payload.customerSubscriptionId ?? state.customerSubscriptionId,
          isMobileVerified: payload.isMobileVerified ?? state.isMobileVerified,
          sourceType: payload.sourceType ?? state.sourceType,
          isAllInOneSubscriptionActive:
            payload.isAllInOneSubscriptionActive ??
            state.isAllInOneSubscriptionActive,
          allInOnePlanFrequency:
            payload.allInOnePlanFrequency ?? state.allInOnePlanFrequency,
          pan: payload.pan ?? state.pan,
          dateOfBirth: payload.dateOfBirth ?? state.dateOfBirth,
          aadharNumber: payload.aadharNumber ?? state.aadharNumber,
          isPanUploaded: mergeStoredKycUploadFlag(
            state.isPanUploaded,
            payload.isPanUploaded,
          ),
          isAadhaarFrontUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarFrontUploaded,
            payload.isAadhaarFrontUploaded,
          ),
          isAadhaarBackUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarBackUploaded,
            payload.isAadhaarBackUploaded,
          ),
          documentStatus: payload.documentStatus ?? state.documentStatus,
          ...nextCkycVerificationFromPayload(state, payload),
        };
      }

      case onboardingConstants.ONBOARDING_DATA_REQUEST: {
        return {
          ...state,
          loading: {
            ...state.loading,
            onboardingData: 1,
          },
        };
      }

      case onboardingConstants.ONBOARDING_DATA_RESPONSE: {
        return {
          ...state,
          isInitialFetched: 1,
          currentStage: payload.currentStage ?? state.currentStage,
          riskMasterId: payload.riskMasterId || state.riskMasterId,
          riskProfileName: payload.riskProfileName || state.riskProfileName,
          suggestedRiskId: payload.suggestedRiskId || state.suggestedRiskId,
          investmentAmount: payload.investmentAmount || state.investmentAmount,
          investmentTenure: payload.investmentTenure || state.investmentTenure,
          investmentStrategy: payload.investmentStrategy,
          isOnboardingCompleted:
            payload.isOnboardingCompleted ?? state.isOnboardingCompleted,
          isPaymentCompleted:
            payload.isPaymentCompleted ?? state.isPaymentCompleted,
          minInvestmentAmount:
            payload.minInvestmentAmount || state.minInvestmentAmount,
          minimumAdditionalInvestAmount:
            payload.minimumAdditionalInvestAmount ||
            state.minimumAdditionalInvestAmount,
          portfolioGeneratedDate:
            payload.portfolioGeneratedDate || state.portfolioGeneratedDate,
          expiryDate: payload.expiryDate || state.expiryDate,
          dateOfBirth: payload.dateOfBirth || state.dateOfBirth,
          pan: payload.pan || state.pan,
          aadharNumber: payload.aadharNumber || state.aadharNumber,
          isPanUploaded: mergeStoredKycUploadFlag(
            state.isPanUploaded,
            payload.isPanUploaded,
          ),
          isAadhaarFrontUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarFrontUploaded,
            payload.isAadhaarFrontUploaded,
          ),
          isAadhaarBackUploaded: mergeStoredKycUploadFlag(
            state.isAadhaarBackUploaded,
            payload.isAadhaarBackUploaded,
          ),
          documentStatus: payload.documentStatus ?? state.documentStatus,
          ...nextCkycVerificationFromPayload(state, payload),
          loading: {
            ...state.loading,
            onboardingData: 0,
          },
          planId: payload.planId || state.planId,
          hasOnboardingInvestmentDetailsConfirmed:
            payload.hasOnboardingInvestmentDetailsConfirmed ||
            state.hasOnboardingInvestmentDetailsConfirmed,
          customerSubscriptionId:
            payload.customerSubscriptionId || state.customerSubscriptionId,
          isMobileVerified: payload.isMobileVerified || state.isMobileVerified,
          sourceType: payload.sourceType || state.sourceType,
          isAllInOneSubscriptionActive:
            payload.isAllInOneSubscriptionActive ??
            state.isAllInOneSubscriptionActive,
          allInOnePlanFrequency:
            payload.allInOnePlanFrequency || state.allInOnePlanFrequency,
        };
      }

      case onboardingConstants.PORTFOLIO_DATA_REQUEST: {
        return {
          ...state,
          portfolioData: initialState.portfolioData,
          marketBreakupData: initialState.marketBreakupData,
          sectorBreakupData: initialState.sectorBreakupData,
          loading: {
            ...state.loading,
            portfolioData: 1,
          },
        };
      }

      case onboardingConstants.PORTFOLIO_DATA_RESPONSE: {
        return {
          ...state,
          portfolioData: payload.portfolioData || state.portfolioData,
          marketBreakupData:
            payload.marketBreakupData || state.marketBreakupData,
          sectorBreakupData:
            payload.sectorBreakupData || state.sectorBreakupData,
          loading: {
            ...state.loading,
            portfolioData: 0,
          },
        };
      }

      case onboardingConstants.PRICING_DATA_REQUEST: {
        return {
          ...state,
          loading: {
            ...state.loading,
            pricingData: 1,
          },
          pricingData: initialState.pricingData,
        };
      }

      case onboardingConstants.PRICING_DATA_RESPONSE: {
        return {
          ...state,
          loading: {
            ...state.loading,
            pricingData: 0,
          },
          pricingData: payload,
        };
      }

      case onboardingConstants.RESET_ONBOARDING_DATA: {
        return initialState;
      }

      default:
        return state;
    }
  },
);
